app.directive('mobileNumber', function() {

  function link(scope, element, attr, ctrl) {
    ctrl.$validators.invalidMobileNumberFormat = function(modelValue, viewValue) {
      return /^(20|30|31|50|70|__|)[0-9]{7}$/.test(modelValue);
    };
  }

  return {
    restrict : 'A',
    require : 'ngModel',
    link : link
  };
});
